import React, { useState } from "react";
import CustomHeading from "../../common/CustomHeading";
import CustomSearch from "../../common/CustomSearch";
import CustomButton from "../../common/CustomButton";
import CustomTable from "../../common/CustomTable";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { BiEdit } from "react-icons/bi";
import { Sidebar } from "primereact/sidebar";
import CustomSidebar from "../../common/CustomSidebar";
import UserInfoSidebar from "./UserInfoSidebar";
import useUser from "../../../hooks/useUser";

import { ToastContainer } from "react-toastify";
import InfoModel from "../../shareableContainer/InfoModel";

const UserList = () => {
  const {
    searchTerm,
    setSearchTerm,
    selectedRole,
    handleRoleChange,
    userList,
    userCount,
    pageSize,
    currentPage,
    nextPageToken,
    prevPageToken,
    hasMore,
    loading,
    handleSearchSubmit,
    handleSearchChange,
    handlePageChange,
    handlePageSizeChange,
    handleUserCreate,
    handleUserUpdate,
    userForm,
    setUserForm,
    visibleForm,
    setVisibleForm,
    handleUserDetails,
    handleToggleClick,
    dealCount,
    leadCount,
    status,
    infoShow,
    setInfoShow,
    roleCount,
    handleReassignLead,
    handleDealReassign,
    handleDeactiveUser,
    user,
  } = useUser();

  const columns = [
    {
      key: "name",
      title: "Name",
      render: (text , record) => (
        <div
        
          className=" capitalize truncate cursor-pointer text-center"
        >
          <div className="flex text-start flex-col gap-2 " >
            <div className="capitalize">
            {record?.name}
            </div>
            <div className="text-customGreen">
           Emp ID : {record?.employeeId}
            </div>
          </div>
        
        </div>
      ),
    },
    {
      key: "role",
      title: "Role",
      render: (text) => <div className="truncate">{text}</div>,
    },
    {
      key: "teamName",
      title: "Team",
      render: (text) => {
        const teamName = text[0]?.name;
        const teamLength = text?.length;
        const teamText = text.map((team) => team.name).join(", ");
        return (
          <div title={teamText} className="truncate cursor-pointer">
            {teamName ? teamName : "No Team"}
            {teamLength > 1 && (
              <span className="text-blue-500 ml-2">+{teamLength - 1}</span>
            )}
          </div>
        );
      },
    },
    {
      key: "status",
      title: "Status",
      render: (text) => (
        <div className="truncate">
          {text ? (
            <span className="text-green-500 font-semibold">{"Active"}</span>
          ) : (
            <span className="text-red-500 font-semibold">{"Inactive"}</span>
          )}
        </div>
      ),
    },
    {
      key: "Action",
      title: "Action",
      render: (_, record) => (
        <div
          onClick={() => {setVisibleForm(true)
            handleUserDetails(record)
          }}
          className="flex justify-center items-center h-full cursor-pointer"
        >
          <BiEdit className="text-blue-500 text-lg" />
        </div>
      ),
    },
  ];

  const userTab = [
    { lable: "All Users", count: roleCount?.totalUsers || 0 },
    { lable: "BOD", count: roleCount?.BOD || 0 },
    { lable: "Telecaller", count: roleCount?.TELECALLER || 0 },
    { lable: "Marketing Executive", count: roleCount?.MARKETING_EXECUTIVE || 0 },
    { lable: "Field Worker", count: roleCount?.FIELD_WORKER || 0 },
    { lable: "MD", count: roleCount?.MD || 0 },
    { lable: "Admin", count: roleCount?.ADMIN || 0 },
    { lable: "Lead Uploader", count: roleCount?.LEAD_UPLOADER || 0 },
    { lable: "CMO", count: roleCount?.CMO || 0 },
  ];

  console.log("userList", userList) 
  console.log("userForm", userForm);

  return (
    <>
      <div>
         <AdminAppBar />
        <ToastContainer/>
        <div className="pt-28 px-6">
          <div className="flex items-center justify-between">
            <CustomHeading
              title={
                <>
                  Users 
                </>
              }
              isIcon={true}
            />
            <div className="flex items-center gap-4">
              <CustomSearch
                placeholder={"Search User"}
                searchTerm={searchTerm}
                handleSearchSubmit={handleSearchSubmit}
                handleSearchChange={handleSearchChange}
              />
              <CustomButton
                label={"Create User"}
                onClick={() => setVisibleForm(true)}
              />
            </div>
          </div>

          <div className="flex items-center justify-between mt-8">
            <div className="flex overflow-x-auto py-5 md:justify-start gap-3 hide-scrollbar">
              {userTab.map((list, index) => (
                <button
                  key={index}
                  onClick={() =>
                    handleRoleChange(
                      list.lable === "All Users" ? null : list.lable
                    )
                  }
                  className={`px-6 h-[50px] rounded-3xl whitespace-nowrap ${
                    selectedRole === list.lable ||
                    (!selectedRole && list.lable === "All Users")
                      ? "bg-white text-customGreen text-base font-semibold shadow"
                      : "bg-white text-gray-700 hover:bg-gray-50"
                  }`}
                >
                  {list.lable} ({list.count})
                </button>
              ))}
            </div>
          </div>

          <div className="w-full mt-[20px]">
            <CustomTable
              columns={columns}
              data={userList}
              isPagination={true}
              pageSize={pageSize}
              onPageChange={handlePageChange}
              onPageSizeChange={handlePageSizeChange}
              currentPage={currentPage}
              nextId={nextPageToken}
              prevId={prevPageToken}
              hasMore={hasMore}
              loading={loading}
            />
          </div>
          <CustomSidebar
            visible={visibleForm}
            onHide={() => {
              setVisibleForm(false);
              setUserForm({
                name: "",
                role: "",
                team: [],
                email: "",
                empId: "",
                phone: "",
                status: true,
              });
            }}
            title="User Information"
          >
            <UserInfoSidebar
              userForm={userForm}
              loading={loading}
              setUserForm={setUserForm}
              handleUserCreate={handleUserCreate}
              handleUserUpdate={handleUserUpdate}
                handleToggleClick={handleToggleClick}
            />
          </CustomSidebar>

          <InfoModel
        show={infoShow}
        leadCount={leadCount}
        dealCount={dealCount}
        reassignHandle={()=>{
            handleReassignLead(userForm?.userId , userForm?.team?.map((team) => team.id) || [])
        }}
        dealReassignHandle={()=>{
            handleDealReassign(userForm?.userId)
        }}
        userDeactiveHandle={()=>{
            handleDeactiveUser(userForm?.userId)
        }}
        title={`${
          leadCount == 0 || dealCount === 0
            ? "Are You Sure"
            : "User Has Active Clients"
        } `}
        message={
          leadCount > 0 ? (
            <>
              This user is currently managing{" "}
              <span className="text-orange-500">
                {leadCount} Clients in leads
              </span>
              . So, Manually Reassign the Responsible person before disabling{" "}
              <span className="text-blue-500">{userForm?.name}</span>.
            </>
          ) : dealCount > 0 ? (
            <>
              This user is currently managing{" "}
              <span className="text-orange-500">
                {dealCount} Clients in Deal
              </span>
              . So, Manually Reassign the Responsible person before disabling{" "}
              <span className="text-blue-500 truncate whitespace-pre-wrap">
                {userForm?.name}
              </span>
              .
            </>
          ) : (
            <>
              “Are you sure you want to disable this user? They will be logged
              out and lose access to the system immediately.”
            </>
          )
        }
        close={() => {
          setInfoShow(false);
          setVisibleForm(true);
        }}
      />
        </div>
      </div>
    </>
  );
};

export default UserList;
